export enum EInvoiceItemType {
  Service = 0,
  Product = 1,
  PrepaymentInvoice = 2, // Acompte
  Other = 3,
}
